import SupplierViewContainer from "./Containers/SupplierViewContainer";
export default SupplierViewContainer;
